import React from 'react';
import {AuthProvider} from '../src/contexts/authContext';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Routers from './routes/routers';
import {RouterProvider} from 'react-router-dom';
import {QueryClient, QueryClientProvider} from 'react-query';
// import {ReactQueryDevtools} from 'react-query/devtools';
import {ThemeProvider} from '@mui/material/styles';
import theme from './theme/theme';
import CssBaseline from '@mui/material/CssBaseline';
import i18n from 'i18next';
import enTranslation from './localization/en.json';
import {I18nextProvider} from 'react-i18next';
import {NotificationProvider} from './pages/NotificationPage/NotificationContext';

i18n.init({
  interpolation: {escapeValue: false},
  lng: 'en',
  resources: {
    en: {
      translation: enTranslation,
    },
  },
});

function App() {
  const queryClient = new QueryClient();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <NotificationProvider>
            <I18nextProvider i18n={i18n}>
              <RouterProvider router={Routers} />
              <ToastContainer />
            </I18nextProvider>
          </NotificationProvider>
        </AuthProvider>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
